import {all, call, put, takeLatest} from '@redux-saga/core/effects';
import {
  BREAK_SETTINGS,
  BREAK_SETTINGS_LIST,
  breakSettingsListSearch,
  breakSettingsListSearchError,
  breakSettingsListSearchSuccess,
  breakSettingsLoadError,
  breakSettingsLoadSuccess,
  breakSettingsSaveError,
  breakSettingsSaveSuccess,
  USER_PREFERENCES,
  userPreferencesLoadError,
  userPreferencesLoadSuccess,
  userPreferencesSaveError,
  userPreferencesSaveSuccess,
} from './Actions';
import authApi from '../../@template/services/auth/authApi/authenticatedApi';
import {apiConfig} from '../../config';
import {PayloadAction} from '@reduxjs/toolkit';
import {ICommonSavePayload} from '../Common.actions';
import {BreakSettingsModel} from '../../types/requests/BreakSettingsModel';
import {UserPreferencesModel} from '../../types/models/UserPreferencesModel';


function* LoadBreakSetting(id: string) {
  console.log('SAGA - settingsSaga - LoadBreakSetting');
  try {
    const res = yield authApi.get(`${apiConfig.coreSettingsPath}/break/${id}`);
    const breakSetting = BreakSettingsModel.fromJS(res.data);
    yield put(breakSettingsLoadSuccess(breakSetting));
  } catch (error) {
    yield put(breakSettingsLoadError(error));
  }
}


function* SaveBreakSetting({ id, submission }: ICommonSavePayload<BreakSettingsModel>) {
  console.log('SAGA - settingsSaga - SaveBreakSetting');
  const breakSettingsPath = id ? `${apiConfig.coreSettingsPath}/break/${id}` : `${apiConfig.coreSettingsPath}/break`
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: id ? 'PUT' : 'POST',
      url: breakSettingsPath,
      data: submission
    });
    const breakSetting = BreakSettingsModel.fromJS(res.data);
    yield put(breakSettingsSaveSuccess(breakSetting));
  } catch (error) {
    yield put(breakSettingsSaveError(error));
  }
}

function* DeleteBreakSetting(id: string) {
  console.log('SAGA - settingsSaga - DeleteBreakSetting');
  const breakSettingsPath = `${apiConfig.coreSettingsPath}/break/${id}`
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'DELETE',
      url: breakSettingsPath,
    });
    yield put(breakSettingsListSearch());
  } catch (error) {
    yield put(breakSettingsSaveError(error));
  }
}



function* SearchBreakSettings(includeDisabled: boolean) {
  console.log('SAGA - settingsSaga - SearchBreakSettings');
  try {
    const inclusion = includeDisabled ? '?include_all=true' : '';
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreSettingsPath}/break${inclusion}`
    });
    const results: BreakSettingsModel[] = res.data.map((setting: BreakSettingsModel) => BreakSettingsModel.fromJS(setting));
    yield put(breakSettingsListSearchSuccess(results));
  } catch (error) {
    yield put(breakSettingsListSearchError(error));
  }
}

function* LoadUserPreferences() {
  console.log('SAGA - settingsSaga - LoadUserPreferences');
  try {
    const res = yield authApi.put(`${apiConfig.coreUserPath}/platform-preferences`);
    const userPreferences = UserPreferencesModel.fromJS(res.data);
    yield put(userPreferencesLoadSuccess(userPreferences));
  } catch (error) {
    yield put(userPreferencesLoadError(error));
  }
}


function* SaveUserPreferences(submission: UserPreferencesModel) {
  console.log('SAGA - settingsSaga - SaveUserPreferences');
  const breakSettingsPath = `${apiConfig.coreUserPath}/platform-preferences`
  try {
    const res = yield authApi.request({
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: breakSettingsPath,
      data: submission
    });
    const userPreferences = UserPreferencesModel.fromJS(res.data);
    yield put(userPreferencesSaveSuccess(userPreferences));
  } catch (error) {
    yield put(userPreferencesSaveError(error));
  }
}

// function* DeleteUserPreferences(id: string) {
//   console.log('SAGA - settingsSaga - DeleteUserPreferences');
//   const breakSettingsPath = `${apiConfig.coreSettingsPath}/platform-preferences`
//   try {
//     const res = yield authApi.request({
//       baseURL: apiConfig.coreUrl,
//       method: 'DELETE',
//       url: breakSettingsPath,
//     });
//
//   } catch (error) {
//     yield put(breakSettingsSaveError(error));
//   }
// }

export function* watchBreakSettingsListRefresh() {
  yield takeLatest(BREAK_SETTINGS_LIST.REFRESH, ({ payload }: PayloadAction<boolean>) => SearchBreakSettings(payload));
}

export function* watchBreakSettingsListSearch() {
  yield takeLatest(BREAK_SETTINGS_LIST.LOAD, ({ payload }: PayloadAction<boolean>) => SearchBreakSettings(payload));
}

export function* watchBreakSettingSave() {
  yield takeLatest(BREAK_SETTINGS.SAVE, ({ payload }: PayloadAction<ICommonSavePayload<BreakSettingsModel>>) => SaveBreakSetting(payload));
}

export function* watchBreakSettingLoad() {
  yield takeLatest(BREAK_SETTINGS.LOAD, ({ payload }: PayloadAction<string>) => LoadBreakSetting(payload));
}

export function* watchBreakSettingDelete() {
  yield takeLatest(BREAK_SETTINGS.DELETE, ({ payload }: PayloadAction<string>) => DeleteBreakSetting(payload));
}

export function* watchUserPreferencesSave() {
  yield takeLatest(USER_PREFERENCES.SAVE, ({ payload }: PayloadAction<UserPreferencesModel>) => SaveUserPreferences(payload));
}

export function* watchUserPreferencesLoad() {
  yield takeLatest(USER_PREFERENCES.LOAD, () => LoadUserPreferences());
}

// export function* watchUserPreferencesDelete() {
//   yield takeLatest(USER_PREFERENCES.DELETE, ({ payload }: PayloadAction<string>) => DeleteUserPreferences(payload));
// }



export default function* settingsSaga() {
  yield all ([
    call(watchBreakSettingsListRefresh),
    call(watchBreakSettingsListSearch),
    call(watchBreakSettingSave),
    call(watchBreakSettingLoad),
    call(watchBreakSettingDelete),
    call(watchUserPreferencesSave),
    call(watchUserPreferencesLoad),
    // call(watchUserPreferencesDelete)
  ])
}
